import type { CityConfig } from "../city-template/types";

export const marysvilleConfig: CityConfig = {
  city: "Marysville",
  state: "Washington",
  stateAbbr: "WA",
  slug: "marysville",
  route: "/marysville",
  title: "Emergency Passport Marysville WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Marysville, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Marysville, Tulalip, Arlington, and all north Snohomish County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Marysville, WA",
  heroSubtitle: "Marysville travelers — from Tulalip Tribes members to Seattle Premium Outlets shoppers to north Snohomish County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of north Snohomish County and the Stillaguamish Valley.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Marysville%20Washington%20in%20north%20Snohomish%20County%20with%20the%20Cascade%20Mountains%20in%20the%20distance%2C%20the%20Tulalip%20Resort%20and%20Seattle%20Premium%20Outlets%20area%2C%20Ebey%20Slough%20waterfront%2C%20residential%20neighborhoods%20with%20Pacific%20Northwest%20evergreen%20trees%2C%20modern%20suburban%20landscape%20with%20Mt%20Pilchuck%20backdrop%2C%20warm%20golden%20afternoon%20sunlight%2C%20North%20Puget%20Sound%20suburban%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=marysville-hero-001&orientation=landscape",
  heroImageAlt: "Marysville Washington north Snohomish County with Tulalip and mountain backdrop",
  geoPosition: "48.0562;-122.1772",
  geoPlacename: "Marysville, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 35 miles south of Marysville via I-5",
  },
  nearbyCitiesZips: [
    { name: "Marysville", zips: "98270, 98271" },
    { name: "Tulalip", zips: "98271" },
    { name: "Arlington", zips: "98223" },
    { name: "Lake Stevens", zips: "98258" },
    { name: "Everett", zips: "98201, 98203, 98204, 98208" },
    { name: "Smokey Point", zips: "98223" },
    { name: "Granite Falls", zips: "98252" },
    { name: "Stanwood", zips: "98292" },
    { name: "Camano Island", zips: "98282" },
    { name: "Silvana", zips: "98287" },
    { name: "Warm Beach", zips: "98292" },
    { name: "Bryant", zips: "98223" },
    { name: "Darrington", zips: "98241" },
    { name: "Lakewood (Smokey Point)", zips: "98223" },
    { name: "Mukilteo", zips: "98275" },
    { name: "Mill Creek", zips: "98012, 98082" },
    { name: "Lynnwood", zips: "98036, 98037" },
    { name: "Mount Vernon", zips: "98273, 98274" },
    { name: "Burlington", zips: "98233" },
    { name: "Snohomish", zips: "98290, 98296" },
    { name: "Monroe", zips: "98272" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — I-5 corridor service, just 35 minutes south" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-store-2-line", title: "Tulalip & Outlet Hub", desc: "Serving Tulalip Tribes, Seattle Premium Outlets, and north Snohomish County communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any north Snohomish County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Everett, WA", route: "/everett" },
    { name: "Urgent passport services in Seattle, WA", route: "/seattle" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Marysville, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 35 minutes south via I-5. Marysville residents can ship from any UPS or FedEx in north Snohomish County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Marysville, Tulalip, Arlington, Smokey Point, Lake Stevens, Granite Falls, Stanwood, and all of north Snohomish County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Marysville and north Snohomish County. From the Tulalip Resort and Seattle Premium Outlets to the residential communities along State Avenue and the Smokey Point area, from the Stillaguamish River Valley to the Camano Island gateway — we serve all of Marysville and the north county.",
  nearbyCitiesIntro: "We serve Marysville and all nearby communities including Tulalip, Arlington, Smokey Point, Lake Stevens, Granite Falls, Stanwood, Camano Island, and Darrington. We also serve Everett, Mukilteo, Mount Vernon, and Burlington. Our service reaches all of north Snohomish County and south Skagit County.",
  howItWorksIntro: "Most Marysville travelers complete everything online and ship documents overnight. No need to drive 35 minutes south on I-5 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Marysville is a growing north Snohomish County community adjacent to the Tulalip Tribes reservation and a major retail destination. Here are the most common passport mistakes we see from north Snohomish County travelers.",
  testimonialsIntro: "Marysville travelers — from Tulalip community members to outlet shoppers to north county families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Marysville, WA? Here are the most common ones we hear from north Snohomish County travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "No I-5 traffic or downtown parking hassle", "Perfect for Tulalip and north county travel needs", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35+ minutes to Seattle on I-5", "Parking and traffic in downtown Seattle"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Marysville travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for Tulalip community travel, family vacations, and north Snohomish County emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — I-5 corridor courier", "Tulalip and north county travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Marysville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your north Snohomish County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Marysville residents and families — including Tulalip community members, outlet shoppers, and north county residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Marysville residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Marysville and north Snohomish County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Marysville and north Snohomish County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Marysville WA", description: "Urgent passport processing for Marysville Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Marysville WA", description: "Fast passport renewal for Marysville Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Marysville WA", description: "New passport application services for Marysville Washington residents applying for their first passport." },
    { name: "Child Passport Marysville WA", description: "Minor passport services for Marysville Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Patricia N.",
      location: "Marysville, WA",
      rating: 5,
      text: "Family trip to Mexico with 7 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on State Avenue and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mike & Susan T.",
      location: "Arlington, WA",
      rating: 5,
      text: "Family reunion in London with 10 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 5 days. We shipped from FedEx in Smokey Point and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "James R.",
      location: "Lake Stevens, WA",
      rating: 5,
      text: "Business trip to Tokyo with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Not having to deal with I-5 traffic to Seattle was a game changer.",
      service: "Emergency Passport",
    },
    {
      name: "Angela K.",
      location: "Tulalip, WA",
      rating: 5,
      text: "Lost my passport two weeks before a trip to Vancouver BC. Fast Passport Center replaced it in 3 days. The courier service saved me from having to drive to Seattle during rush hour.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "mar-1",
      name: "Marysville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4207 88th St NE",
      city: "Marysville",
      state: "WA",
      zip: "98270",
      phone: "(360) 659-3511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Marysville, near State Avenue corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Marysville acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Marysville and the Getchell area.",
      icon: "ri-mail-line",
    },
    {
      id: "mar-2",
      name: "Everett Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3102 Hoyt Ave",
      city: "Everett",
      state: "WA",
      zip: "98201",
      phone: "(425) 259-1421",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Everett, approximately 8 miles south of Marysville via I-5",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in Snohomish County. Convenient for south Marysville and Tulalip residents. Good alternative with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "mar-3",
      name: "Arlington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "204 N Olympic Ave",
      city: "Arlington",
      state: "WA",
      zip: "98223",
      phone: "(360) 435-2925",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Arlington, approximately 8 miles north of Marysville via I-5",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Arlington, Smokey Point, and north Snohomish County. Good alternative for north county residents.",
      icon: "ri-mail-line",
    },
    {
      id: "mar-4",
      name: "Lynnwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6817 208th St SW",
      city: "Lynnwood",
      state: "WA",
      zip: "98036",
      phone: "(425) 771-1313",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lynnwood, approximately 18 miles south of Marysville via I-5",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves south Snohomish County. Ample parking near Alderwood Mall. Good alternative for south Marysville residents.",
      icon: "ri-mail-line",
    },
    {
      id: "mar-5",
      name: "Snohomish County Clerk — Everett",
      type: "County Clerk Passport Acceptance",
      address: "3000 Rockefeller Ave, M/S 605",
      city: "Everett",
      state: "WA",
      zip: "98201",
      phone: "(425) 388-3466",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Everett Snohomish County Courthouse, approximately 10 minutes south",
      website: "https://www.snohomishcountywa.gov/",
      websiteLabel: "Snohomish County",
      notes: "Snohomish County Clerk passport acceptance. Extended hours compared to post office. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-5 traffic to downtown Seattle", fpc: "No — ship from Marysville" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "North County Advantage", agency: "No special guidance", fpc: "Yes — Tulalip and north Snohomish County expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Marysville families and Tulalip community travelers often discover passport issues just before summer vacations. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on State Avenue or at Smokey Point sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Snohomish County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Marysville and Everett Post Office appointments fill during summer and around holiday shopping at Seattle Premium Outlets. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating I-5 Rush Hour Traffic",
      description: "Many Marysville residents attempt to drive to the Seattle passport agency. I-5 southbound from Marysville during morning rush hour can take 60–90 minutes. Between traffic and Seattle parking, this becomes a half-day commitment — our courier service eliminates all of that.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Summer family vacations and Tulalip community travel both peak May–August in north Snohomish County — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Marysville area or north Snohomish County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Marysville, Everett, or Arlington." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to battle I-5 traffic yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Marysville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Marysville, WA?", a: "Fast Passport Center offers emergency passport processing in Marysville, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 35 minutes south via I-5." },
    { q: "Does Marysville have its own passport agency?", a: "No — Marysville does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 35 minutes south via I-5). Fast Passport Center's courier service means Marysville residents never need to deal with I-5 traffic and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Arlington, Tulalip, or Lake Stevens?", a: "Absolutely. Fast Passport Center serves all of north Snohomish County including Arlington, Tulalip, Smokey Point, Lake Stevens, Granite Falls, and Stanwood. Our service works the same way everywhere." },
    { q: "What airport do Marysville travelers use for international flights?", a: "Paine Field (PAE) in Everett is just 15 minutes from Marysville with Alaska Airlines and United flights. For international travel, Seattle-Tacoma International Airport (SEA) is the primary gateway — approximately 40–50 minutes south via I-5. Always verify passport validity for at least 6 months past your return date." },
    { q: "Does Fast Passport Center serve the Tulalip Tribes community?", a: "Yes. Fast Passport Center serves all of north Snohomish County including the Tulalip Tribes reservation and community. We understand the unique travel needs of tribal members and can accommodate urgent passports for cultural travel, business, and family visits." },
    { q: "How much does an expedited passport cost in Marysville, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Marysville?", a: "Walgreens, CVS, and Rite Aid stores throughout Marysville and Everett offer passport photos. UPS Store and FedEx Office locations also provide them. Locations on State Avenue and at Seattle Premium Outlets offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Is Marysville considered part of the Seattle metro for passport purposes?", a: "Yes — Marysville is part of the Seattle metro area for passport processing. The Seattle Passport Agency serves all of Snohomish County. Our courier service provides the same fast 24–48 hour turnaround for Marysville residents as it does for Seattle residents — just with less traffic and no parking headaches." },
  ],
  photoLocations: [
    { name: "Walgreens — State Avenue", address: "9925 State Ave, Marysville, WA 98270", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Rite Aid — Smokey Point", address: "3704 172nd St NE, Arlington, WA 98223", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Marysville", address: "1227 4th St, Marysville, WA 98270", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Everett", address: "10121 Evergreen Way, Everett, WA 98204", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Smokey Point", address: "5010 172nd St NE, Arlington, WA 98223", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Closest Washington Department of Licensing office to Marysville. Driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Everett", address: "5314 Evergreen Way, Everett, WA 98203", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves south Marysville and Everett. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "PAE",
      name: "Paine Field — Snohomish County Airport",
      distance: "15 minutes south of Marysville via I-5",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Closest commercial airport to Marysville. Alaska Airlines and United serve select domestic destinations. Free parking, short security lines, and no Seattle traffic. Perfect for domestic travel connections.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "40–50 minutes south of Marysville via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary international airport for Snohomish County travelers. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: false,
    },
    {
      code: "BLI",
      name: "Bellingham International Airport",
      distance: "Approximately 55 minutes north of Marysville via I-5",
      address: "4255 Mitchell Way, Bellingham, WA 98226",
      note: "Alternative airport for north Snohomish County residents. Alaska Airlines serves BLI with connections through Seattle. Seasonal flights available.",
      flightUrl: "https://www.portofbellingham.com/",
      flightLabel: "BLI Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Washington State Department of Health Vital Records. Online, mail, or in-person options for Snohomish County residents.", url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through WA DOH Vital Records. Required for estate, insurance, and legal matters.", url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Snohomish County Auditor. Certified copies available for name changes.", url: "https://www.snohomishcountywa.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Snohomish County Clerk. Required for name change passport corrections.", url: "https://www.snohomishcountywa.gov/" },
  ],
};